// @flow

import Cookie from './Cookie';
import Cookies from '../constants/Cookies';

export default class AsyncRequest {
  /**
   *
   */
  static get<T>(apiUrl: string): Promise<T> {
    return fetch(apiUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-CSRF-TOKEN': document.getElementByRef('csrf-token')?.getAttribute('content') || '',
        'X-XSRF-TOKEN': Cookie.get(Cookies.XSRF_TOKEN)
      }
    }).then((response: Object) => response.json()).then((data: Object) => ({ data }));
  }

  /**
   *
   */
  static async post<T>(apiUrl: string, parameters: Object = {}, route: string = '/proxy'): Promise<T> {
    parameters.api_method = apiUrl;

    return fetch(route, {
      method: 'POST',
      body: JSON.stringify(parameters),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.getElementByRef('csrf-token')?.getAttribute('content') || ''
      }
    }).then((response: Object) => response.json()).then((data: Object) => ({ data }));
  }
}
